<template>
  <div class="charge-step wizard-step">
    <div class="wizard-step-body">
      <!-- チャージ一覧（カード内スクロール） -->
      <section class="wizard-section-card wizard-section-card--fill">
        <div class="wizard-section-scroll px-4 py-3">
          <div class="text-caption text--secondary mb-2">
            チェックすると追加されます
          </div>
          <div
            v-for="(item, idx) in items"
            :key="`charge-${item.id}`"
          >
            <div class="d-flex align-center py-2">
              <v-checkbox
                :input-value="isEnabled(item.id)"
                :label="item.name"
                hide-details
                class="ma-0 flex-grow-1"
                @change="handleToggle(item, $event)"
              />
              <div
                class="text-right"
                style="min-width: 100px;"
              >
                {{ formatPrice(item.sellingPrice) }} 円
              </div>
            </div>
            <v-divider v-if="idx < items.length - 1" />
          </div>
        </div>
      </section>

      <!-- 合計サマリー -->
      <section class="wizard-section-card">
        <div class="wizard-section-body d-flex justify-space-between align-center">
          <span class="text-body-1 font-weight-medium">合計</span>
          <span class="text-h5 font-weight-bold primary--text">{{ formatPrice(totalPrice) }} 円</span>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'

export default {
  name: 'ChargeStep',
  props: {
    // TableInitConfig.items 由来のチャージ商品マスタ
    items: { type: Array, required: true },
    // formState.charges = [{ vendibleId, sellingPrice, enabled }]
    charges: { type: Array, default: () => [] },
  },
  emits: ['update:charges'],
  setup(props, { emit }) {
    // charges が空 or items と同期していない場合に初期値（全 OFF）を返す
    const effectiveCharges = computed(() => {
      if (props.charges && props.charges.length > 0) {
        // items に含まれるが charges 未登録のものは追加（未登録は OFF 扱い）
        const map = new Map(props.charges.map(c => [c.vendibleId, c]))

        return props.items.map(it => map.get(it.id) || {
          vendibleId: it.id, sellingPrice: it.sellingPrice, enabled: false,
        })
      }

      return props.items.map(it => ({
        vendibleId: it.id, sellingPrice: it.sellingPrice, enabled: false,
      }))
    })

    const isEnabled = id => {
      const found = effectiveCharges.value.find(c => c.vendibleId === id)

      return found?.enabled === true
    }

    const totalPrice = computed(() => effectiveCharges.value
      .filter(c => c.enabled === true)
      .reduce((sum, c) => sum + Number(c.sellingPrice || 0), 0))

    const formatPrice = n => Number(n || 0).toLocaleString('ja-JP')

    const handleToggle = (item, checked) => {
      const next = effectiveCharges.value.map(c => (
        c.vendibleId === item.id ? { ...c, enabled: Boolean(checked) } : c
      ))
      emit('update:charges', next)
    }

    return {
      isEnabled, totalPrice, formatPrice, handleToggle,
    }
  },
}
</script>
